import React, { useEffect } from 'react'
import Signup from '../components/Signup/Signup'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";

const SignupPage = () => {

    const navigate = useNavigate();
    const { isAuthenticated } = useSelector((state) => state.user);
    // If user is already logged in, redirect to profile overview
    useEffect(() => {
        if (isAuthenticated) {
            navigate("/profile/overview", { replace: true });
        }
    }, [isAuthenticated, navigate]);

    return (
        <div>
            <Header />
            <Signup />
            <Footer />
        </div>
    )
}

export default SignupPage